import * as React from 'react';

import { SyncLoader } from 'react-spinners';
import styled from 'styled-components';
import { getCSSVarValue } from 'utils';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Spinner = () => {
  const color = getCSSVarValue('--secondary-text-color');
  return (
    <Wrapper>
      <SyncLoader color={color} />;
    </Wrapper>
  );
};



// WEBPACK FOOTER //
// ./src/components/Spinner.tsx